export default function decimalToHex(decimal: string): string {
  const num = parseInt(decimal, 10); // Convert string to number
  return `${num.toString(16).padStart(6, '0')}`;
}